import cx from 'classnames';
import React from 'react';
import styles from '../card.module.scss';
export const CardAction = ({ children, className }) => {
    const cardActionClass = cx(styles.actionButton, className);
    return React.createElement("div", { className: cardActionClass }, children);
};
//# sourceMappingURL=card-action.js.map